import { ActionReducerMap, createFeatureSelector, StoreModule } from '@ngrx/store';

import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { Prodotto, Category } from '../../../models/Prodotto';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { CategoryModalComponent } from '../components/category-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { reducer as listReducer} from './list/reducer';
import { reducer as categoriesReducer} from './categories/reducer';
import { reducer as brandsReducer, deleteErrorReducer as brandsDeleteErrorReducer } from './brands/reducer';
import { reducer as errorsReducer} from './errors/reducer';
import { FeatureEffects as ListEffects } from './list/effects';
import { FeatureEffects as CategoriesEffects } from './categories/effects';
import { FeatureEffects as BrandsEffects } from './brands/effects';
import { BrandModalComponent } from '../components/brand-modal.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { FeatureState } from './settings';
import { ItemModalComponent } from '../components/item-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgCanModule } from '../../../shared/directives/ng-can.module';

const reducers: ActionReducerMap<FeatureState> = {
    list: listReducer,
    categories: categoriesReducer,
    brands: brandsReducer,
    brandsDeleteError: brandsDeleteErrorReducer,
    errors: errorsReducer
}

@NgModule({
    declarations: [
        ItemModalComponent,
        CategoryModalComponent,
        BrandModalComponent,
    ],
    imports: [
        NgbModalModule,
        ReactiveFormsModule,
        CommonModule,
        ColorPickerModule,
        NgSelectModule,
        NgCanModule,
        StoreModule.forFeature('prodotti', reducers),
        EffectsModule.forFeature([ListEffects, CategoriesEffects, BrandsEffects])
    ],
    entryComponents: [
        ItemModalComponent,
        CategoryModalComponent,
        BrandModalComponent
    ]
})

export class FeatureStoreModule {
}


